










import { Component, PropSync, Emit } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component({
  name: 'HsNoData',
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  @PropSync('visible') syncVisible: boolean

  @Emit()
  click() {}
}
